module.exports = __webpack_public_path__ + "img/2020_048.7eb0bd96.jpg";